import React, { ReactElement } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Loader } from 'idsk-react-components';
import { ClientStatus } from '../../model/ClientStatus';
import SendPripomienkyComponent from './component/SendPripomienkyComponent';
import routes from '../../routing/routes';
import Pripomienka from '../../model/pripomienka/Pripomienka';
import ConfirmAction from '../ConfirmAction/ConfirmAction';

interface Props {
  status: ClientStatus;
  pripomienkyForSend: Array<Pripomienka>;
}
const SendPripomienky = ({
  status,
  pripomienkyForSend,
}: Props): ReactElement => {
  const navigate = useNavigate();
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  return (
    <Loader loading={status.loading}>
      <>
        { (status.responseCode < 400 && pripomienkyForSend != null) && (
        <>
          <ConfirmAction
            doAfterCancel={() => navigate(routes.pripomienky.list.withParams(type, year, index))}
          />
          <SendPripomienkyComponent
            pripomienkyForSend={pripomienkyForSend}
          />
        </>
        )}
      </>
    </Loader>
  );
};

export default SendPripomienky;
